import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import NotificationButton from '../../components/NotificationButton';
import ComplaintsButton from '../../components/ComplaintsButton';
import monolitLogo from '../../assets/monolit-logo.svg';
import { isCatSoundOn, setCatSound, playMeow } from '../../utils/catMeow';

import '../../theme/redesign/tokens.css';
import '../../theme/redesign/header.css';

function Header({ products, seasonTheme, isSeasonThemeOn, toggleSeasonTheme }) {
  const isCatTheme = isSeasonThemeOn && seasonTheme.id === 'cat';
  const [soundOn, setSoundOn] = useState(() => isCatSoundOn());

  const toggleSound = () => {
    const next = !soundOn;
    setSoundOn(next);
    setCatSound(next);
    if (next) playMeow(); // проигрываем «мяу» как подтверждение включения
  };

  return (
    <header className="rd-page-head">
      <div className="rd-page-head__brand">
        <div className="rd-page-head__mark">
          <img src={monolitLogo} alt="TDM" />
        </div>
        <h1 className="rd-page-head__title">
          Калькуляторы
          <small>Единая точка расчёта стоимости и&nbsp;доставки</small>
        </h1>
      </div>

      <div className="rd-page-head__right">
        <button
          className={`rd-theme-toggle rd-theme-toggle--${seasonTheme.id}${isSeasonThemeOn ? ' rd-theme-toggle--active' : ''}`}
          onClick={(e) => {
            const btn = e.currentTarget;
            const rect = btn.getBoundingClientRect();
            // «мяу» при включении кошко-темы, если звук разрешён
            if (!isSeasonThemeOn && seasonTheme.id === 'cat' && soundOn) playMeow();
            toggleSeasonTheme({
              x: Math.round(rect.left + rect.width / 2),
              y: Math.round(rect.top + rect.height / 2),
            });
            btn.classList.add('rd-theme-toggle--pulsing');
            setTimeout(() => btn.classList.remove('rd-theme-toggle--pulsing'), 500);
          }}
          title={isSeasonThemeOn ? seasonTheme.titleOff : seasonTheme.titleOn}
          aria-pressed={isSeasonThemeOn}
          type="button"
        >
          <span className="rd-theme-toggle__track" />
          <span className="rd-theme-toggle__thumb">
            {isSeasonThemeOn ? seasonTheme.icon : '🏢'}
          </span>
        </button>
        {isCatTheme && (
          <button
            className="rd-icon-btn rd-cat-sound-btn"
            onClick={toggleSound}
            title={soundOn ? 'Выключить звук Мурки' : 'Включить звук Мурки (мяу)'}
            aria-pressed={soundOn}
            type="button"
          >
            <i className={`bi ${soundOn ? 'bi-volume-up-fill' : 'bi-volume-mute-fill'}`} />
          </button>
        )}
        <NotificationButton />
        <ComplaintsButton products={products} />
        <Link to="/price-lists" className="rd-page-head__link">
          Сводная&nbsp;прайсов
        </Link>
        <Link to="/warehouse-murino" className="rd-page-head__link">
          Склад&nbsp;Мурино
        </Link>
        <Link to="/catalog" className="rd-page-head__link">
          Каталог&nbsp;товаров
        </Link>
      </div>
    </header>
  );
}

export default Header;
